import capitalize from 'lodash/capitalize';
import { getGraphEditConfig } from '../custom-report.serivce';
import EditSection from './useEditableWidget/EditSection/EditSection';
import { EDIT_CONFIG_BY_WIDGET_TYPE } from './useEditableWidget/consts';
import { METRIC_TYPE } from './consts/graphTypes';

const useEditableWidget = ({ graph, filters, onChange, onSave, onRemove }) => {
  const { metricType = 'default' } = graph;

  const getEditConfig =
    EDIT_CONFIG_BY_WIDGET_TYPE[metricType] ??
    EDIT_CONFIG_BY_WIDGET_TYPE.default;

  const editConfig = getEditConfig({
    graph,
    filters,
    onChange,
    onSave,
    onRemove
  });

  const graphEditConfig = getGraphEditConfig({
    type: filters.filterType,
    teams: filters.globallySelectedTeams,
    labels: filters.selectedLabels
  });

  const handleChange = (field, value) => {
    const updatedWidget = {
      ...graph,
      [field]: value
    };
    if (editConfig.onChange) {
      editConfig.onChange(
        updatedWidget,
        ![METRIC_TYPE.pm, METRIC_TYPE.reported].includes(graph.metricType)
      );
    }
  };

  const managedFields = Object.keys(editConfig.editableFields ?? {}).reduce(
    (acc, field) => {
      return {
        ...acc,
        [`set${capitalize(field)}`]: value => handleChange(field, value)
      };
    },
    {}
  );

  const attachEditableFieldsToGraph = graph =>
    Object.keys(editConfig.editableFields ?? {}).reduce((acc, field) => {
      return {
        ...acc,
        [field]: editConfig.editableFields?.[field] ?? acc[field]
      };
    }, graph);

  return {
    ...managedFields,
    graphEditConfig,
    editConfig,
    isEditable: editConfig.isEditable ?? false,
    EditSection: editConfig.EditSection ?? EditSection,
    editableWidget: attachEditableFieldsToGraph(graph)
  };
};

export default useEditableWidget;
